import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const GlobalStateContext = createContext();

// Define the provider component
export const GlobalStateProvider = ({ children }) => {
  // Load globalList from localStorage or initialize as empty array
  const [globalList, setGlobalList] = useState(() => {
    try {
      const savedList = localStorage.getItem('globalList');
      if (savedList) {
        return JSON.parse(savedList);
      }
    } catch (error) {
      console.error('Error loading globalList from localStorage:', error);
    }
    return [];
  });
  const [playlistCache, setPlaylistCache] = useState({});
  const [isLoggedInSpotify, setIsLoggedInSpotify] = useState(true);
  const [showGuide, setShowGuide] = useState(false);

  // Save globalList to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem('globalList', JSON.stringify(globalList));
    } catch (error) {
      console.error('Error saving globalList to localStorage:', error);
    }
  }, [globalList]);

  // Function to directly set the global list
  const updateGlobalList = (newList) => {
    setGlobalList(newList);
  };
  const CACHE_EXPIRY = 5 * 60 * 1000; // 5 minutes
  const MAX_CACHE_ITEMS = 30; // Limit number of cached services

  const getCachedPlaylists = (serviceKey) => {
    const cachedItem = playlistCache[serviceKey];
    if (!cachedItem) return null;
    
    // Check if cache has expired
    if (Date.now() - cachedItem.timestamp > CACHE_EXPIRY) {
      // Remove expired item
      const { [serviceKey]: _, ...restCache } = playlistCache;
      setPlaylistCache(restCache);
      return null;
    }
    
    return cachedItem.data;
  };

  const setCachedPlaylists = (serviceKey, data) => {
    setPlaylistCache(prev => {
      // If cache is full, remove oldest item
      const entries = Object.entries(prev);
      if (entries.length >= MAX_CACHE_ITEMS) {
        const [oldestKey] = entries.sort(([,a], [,b]) => a.timestamp - b.timestamp)[0];
        const { [oldestKey]: _, ...rest } = prev;
        return {
          ...rest,
          [serviceKey]: { data, timestamp: Date.now() }
        };
      }
      
      return {
        ...prev,
        [serviceKey]: { data, timestamp: Date.now() }
      };
    });
  };

  const addToList = (newItem) => {
    setGlobalList([...globalList, newItem]);
  };

  const addListToGlobalList = (newList) => {
    setGlobalList([...globalList, ...newList]);
  };

  const clearGlobalList = () => {
    setGlobalList([]);
    localStorage.removeItem('globalList');
  };

  const clearPlaylistCache = () => {
    setPlaylistCache({});
  };
  return (
    <GlobalStateContext.Provider value={{ 
      globalList, 
      addToList, 
      addListToGlobalList,
      clearGlobalList,
      getCachedPlaylists,
      setCachedPlaylists,
      clearPlaylistCache,
      setGlobalList: updateGlobalList,
      isLoggedInSpotify,
      setIsLoggedInSpotify,
      showGuide,
      setShowGuide
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
